<template>
  <div class="content-wrapper">
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
        Chats
        <small>All chats in one page</small>
      </h1>

    </section>

    <!-- Main content -->
    <section class="content">
      <!-- Default box -->
      <div class="box">
        <!-- /.box-body -->
        <div class="box-footer">
          <iframe v-for="server in servers" :src="'/static/chats/chat-main.html?ip=' + server.ip + ':' + server.gamePort + '&nickname=' + safeName + '&server=' + encodeURIComponent(server.name)"></iframe>
        </div>
        <!-- /.box-footer-->
      </div>
      <!-- /.box -->

    </section>
    <!-- /.content -->
  </div>
</template>

<script>
  export default {
    name: 'ChatsIndex',
    data: function () {
      return {
        servers: [],
        form: new Form({}),
        nickname: 'SERVER'
      }
    },
    computed: {
      safeName: function () {
        return encodeURIComponent(this.nickname)
      }
    },
    mounted: function () {
      var self = this

      this.nickname = this.$store.state.nickname
      setTimeout(function () {
        self.nickname = self.$store.state.nickname
        self.form.post(baseUrl2 + '/data/servers.php', {}).then(function (result) {
          self.servers = result.servers
        }, function (reason) {
            // rejection
          console.log('Rejected', reason)
        })
      }, 500)
    }
  }
</script>

<style scoped>
  iframe {
    width: 24%;
    height: 380px;

  }
  @media screen and (max-width: 992px) {
    iframe {width: 49%;}
  }
  @media screen and (max-width: 768px) {
    iframe {width: 95%;}
  }
  @media screen and (max-width: 480px) {
    iframe {width: 95%;}
  }
</style>



// WEBPACK FOOTER //
// Index.vue?ac890680